import React, { Component } from 'react';
import './HomeBanner.css';

class HomeBanner extends Component {

  constructor(props) {
    super(props);
    this.state = {
      image: null
    }
  }

  componentWillMount(){
    let images = [
      'apple_mini.jpg',
      'nyc.jpg',
      'candy_mini.jpg',
      'nyc.jpg',
      'topshop_mini.jpg'
    ];
    let rand = images[Math.floor(Math.random() * images.length)];
    this.setState({image: rand});
  }

  render() {
    const { image } = this.state;
    return (
      <div className='home-banner-container'>
        <div className="skew-gradient"></div>
        <div className="pattern-bg">
          <img src={require(`../../../assets/images/${image}`)} alt="Usaproductos" />
        </div>
        <section className="home-banner">
          <div className="container-lg">
            <h1>Vos comprá</h1>
            <h2>
              Nosotros te lo llevamos
              <div className="fadeIn">
                <span>rápido.</span>
                <span>fácil.</span>
                <span>sin impuestos.</span>
                <span>sin trámites.</span>
              </div>
            </h2>
            <a href="#how-it-works">
              ¿Cómo funciona?
            </a>
          </div>
        </section>
      </div>
    );
  }
}

export default HomeBanner;



// WEBPACK FOOTER //
// ./src/components/Home/HomeBanner/HomeBanner.js